import { render, staticRenderFns } from "./DSButtonGroup.vue?vue&type=template&id=3accd283&scoped=true&"
import script from "./DSButtonGroup.vue?vue&type=script&lang=js&"
export * from "./DSButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./DSButtonGroup.vue?vue&type=style&index=0&id=3accd283&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3accd283",
  null
  
)

export default component.exports